import $ from "jquery";

export const menuHandlers = () => {
    const visibleMenuItem = [];

    $('.nav-list__item.dropdown').each(function () {
        if (!$(this).is(':hidden')) {
            visibleMenuItem.push($(this).find('a').text());
        }
    });

    $('.nav-list-dropdown__column > .nav-list-dropdown__column-item').each(function () {
        if (visibleMenuItem.indexOf($(this).find('a').text()) !== -1) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });
};
